const calculateAge = refDateStr => {
  const currentDate = new Date();
  const refDate = new Date(refDateStr);

  const month = currentDate.getMonth() - refDate.getMonth();
  let age = currentDate.getUTCFullYear() - refDate.getUTCFullYear();
  if (month < 0 || (month === 0 && currentDate.getDate() < refDate.getDate())) {
    age -= 1;
  }

  return age;
};

export default { calculateAge };
